import { Container } from './Container'
import PaymentStatus from '../PaymentStatus/Component'
import { Strings } from '../../utils/Strings'
import { Button, CircularProgress, Typography } from '@mui/material'
import { allColors } from '../../themes/Colors'
import PricingBreakdown from '../PricingBreakdown/Component'
import useStyles from './Styles'
import { checkNull } from '../../utils/Helpers'
import { memo } from 'react'
import { customAlphabet, nanoid } from 'nanoid'

const HomePage = () => {
  const { data, func } = Container()
  const styles = useStyles()

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }
      document.body.appendChild(script)
    })
  }

  const resetPage = () => {
    let timeout = setTimeout(() => {
      func('false')
    }, 5000)
    return () => clearTimeout(timeout)
  }

  const loadRazorpay = async () => {
    const uniqueValue = customAlphabet('0123456789', 12)
    const invoiceId = `INVN${uniqueValue()?.toString()}`
    const { amount, order_id, customer_id, transaction_code } =
      data?.orderData ?? {}
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    if (!res) {
      console.log('Razorpay SDK failed to load. Are you online?')
      func(Strings.fail, Strings.authFail)
    }
    const options = {
      key: process.env.REACT_APP_Key, // Replace with your Razorpay key
      amount: amount * 100, // Amount is in paise, so this is 50000 paise or ₹500
      currency: 'INR',
      order_id: order_id,
      customer_id: customer_id,
      handler: function (response) {
        func(Strings.success, Strings.paySuccess)
        // You can send the payment ID to your server for verification here
      },
      modal: {
        confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.
        // This function is executed when checkout modal is closed
        // There can be 3 reasons when this modal is closed.
        ondismiss: async (reason) => {
          // Reason 1 - when payment is cancelled. It can happend when we click cross icon or cancel any payment explicitly.
          if (reason === undefined) {
            func(Strings.fail, Strings.payCancel)
            resetPage()
          }
          // Reason 2 - When modal is auto closed because of time out
          else if (reason === 'timeout') {
            func(Strings.fail, reason)
            resetPage()
          }
          // Reason 3 - When payment gets failed.
          else {
            func(Strings.fail, reason?.error?.description)
            resetPage()
          }
        },
      },
      notes: {
        invoice_number: invoiceId,
      },
      retry: {
        enabled: true,
      },
    }
    // All information is loaded in options which we will discuss later.
    const rzp1 = new window.Razorpay(options)

    // to open razorpay checkout modal.
    rzp1.open()
  }

  return (
    <div style={{ height: '100vh' }}>
      {data?.initialLoading && (
        <div className={styles.container}>
          <CircularProgress
            sx={{
              mb: 3,
            }}
            color='primary'
            style={{
              fontSize: '100px !important',
              color: allColors.primaryColor,
            }}
          />
        </div>
      )}
      {!data?.initialLoading ? (
        data?.payStatus ? (
          <PaymentStatus data={data} />
        ) : (
          <div className={styles.container}>
            {!checkNull(data?.orderData) ? (
              <PricingBreakdown
                data={data}
                func={() => {
                  func(Strings.loading)
                  loadRazorpay()
                }}
              />
            ) : (
              <Typography
                textAlign={'center'}
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                }}
              >
                No Data
              </Typography>
            )}
          </div>
        )
      ) : null}
    </div>
  )
}

export default memo(HomePage)
